export function sharedMethod(it) {
    let content = it.fileContent;
    let filename = it.fileName;
    let fileType = it.fileType;
    try {
      // 根据文件类型设置 MIME 类型和文件名
      let mimeType = "";
      const mimeTypes = {
        txt: "text/plain",
        png: "image/png",
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        pdf: "application/pdf",
        word: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        excel:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        csv: "text/csv",
        html: "text/html",
        json: "application/json",
        xml: "application/xml",
        gif: "image/gif",
        bmp: "image/bmp",
        webp: "image/webp",
        svg: "image/svg+xml",
        mp3: "audio/mpeg",
        wav: "audio/wav",
        ogg: "audio/ogg",
        flac: "audio/flac",
        mp4: "video/mp4",
        webm: "video/webm",
        avi: "video/x-msvideo",
        zip: "application/zip",
        rar: "application/x-rar-compressed",
        tar: "application/x-tar",
        gz: "application/gzip",
        "7z": "application/x-7z-compressed",
        ppt: "application/vnd.ms-powerpoint",
        pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        xls: "application/vnd.ms-excel",
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        odt: "application/vnd.oasis.opendocument.text",
        ods: "application/vnd.oasis.opendocument.spreadsheet",
        epub: "application/epub+zip",
        rtf: "application/rtf",
        js: "application/javascript",
        jsx: "application/javascript",
        ttf: "font/ttf",
        otf: "font/otf",
        woff: "font/woff",
        woff2: "font/woff2",
      };

      mimeType = mimeTypes[fileType] || "application/octet-stream"; // 默认 MIME 类型

      // 将 Base64 字符串转换为二进制数据
      const byteCharacters = atob(content); // 解码 Base64
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename; // 设置下载文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      alert("文件下载失败，请稍后重试。");
    }
  }